import React from 'react';
import { Stack, Typography } from '@mui/material';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';

import type { IntakeStatusBaseSteps } from '@shared/patient-intake-status';

type IdVerificationViewerProps = {
  step: IntakeStatusBaseSteps['ID_VERIFICATION'];
};

// FUTURE: @keeganpotgieter add manual verification status viewer
export const IdVerificationViewer: React.FC<IdVerificationViewerProps> = ({ step }) => {
  if (!step) {
    return null;
  }

  const { status, metadata } = step.currentStatus;

  if (!status || status !== 'COMPLETED' || !metadata) {
    return null;
  }

  if (metadata.verificationMethod === 'MANUAL') {
    return (
      <Stack direction="row" alignItems="center" gap={1}>
        <VerifiedUserIcon color="success" />
        <Typography variant="body2" fontWeight="bold">
          Identity documents have been uploaded. Please review and verify the patient's identity.
        </Typography>
      </Stack>
    );
  }

  return (
    <Stack direction="row" alignItems="center" gap={1} justifyContent="center">
      <VerifiedUserIcon color="success" />
      <Typography variant="body2" fontWeight="bold">
        Digital ID is automatically verified.
      </Typography>
    </Stack>
  );
};
